<template>
  <path d="M8 9V14.5" stroke="currentColor" stroke-width="2" />
  <path d="M14 8H8" stroke="currentColor" stroke-width="2" />
  <path
    d="M2 2L2 1H1L1 2H2ZM3 12L3 2L1 2L1 12H3ZM2 3L12 3V1L2 1L2 3ZM13 4V4.5H15V4L13 4ZM13 4.5V8H15V4.5H13ZM4 15H8V13H4V15ZM12 3C12.5523 3 13 3.44772 13 4L15 4C15 2.34315 13.6569 1 12 1V3ZM1 12C1 13.6569 2.34315 15 4 15V13C3.44772 13 3 12.5523 3 12H1Z"
    fill="currentColor"
  />
  <rect x="5" y="5" width="6" height="6" rx="1" fill="currentColor" />
  <rect width="4" height="4" rx="2" fill="currentColor" />
  <rect x="6" y="12" width="4" height="4" rx="2" fill="currentColor" />
  <rect x="12" y="6" width="4" height="4" rx="2" fill="currentColor" />
</template>
